/* 
 *  This file loading.enum.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

export enum LoadEnum {
    loading = 'loading',
    loaded = 'loaded',
    empty = 'empty',
}
